import { createSignal } from "solid-js"
import { PlayerId } from "../../lib/core/player/PlayerId"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useSelectedPlayerIdSignal = createSharedCachedFactory((
    // engine: Engine
) => {

    // eslint-disable-next-line solid/reactivity
    const signal = createSignal<PlayerId | null>(null)

    return signal
})
